export const EMPLOYEE_CARD_WIDTH = 250;
export const EMPLOYEE_CARD_HEIGHT = 170;
export const SELECTED_EMPLOYEE_QUERY_PARAM = 'selected_employee';
